// assets
import { ArchiveBook } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - RUBRICS ||============================== //

const Rubrics: NavItemType = {
  id: 'group-rubrics',
  title: 'Rubrics',
  type: 'group',
  children: [
    {
      id: 'rubrics',
      title: 'Rubrics',
      type: 'item',
      url: '/rubrics',
      icon: ArchiveBook,
      breadcrumbs: false
    }
  ]
};

export default Rubrics;

